import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SupportSideBarTabs } from '../types';

@Injectable({
  providedIn: 'root'
})
export class SupportSidebarService {


  // for toggle sidebar from other components
  private activeTab = new Subject<SupportSideBarTabs>();

  public activeTab$ = this.activeTab.asObservable();

  constructor() { }

  public changeSideBarActiveTab(activeTab: SupportSideBarTabs): void {
    this.activeTab.next(activeTab);
  }
}
